import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TimesheetsFeatureService } from '@features';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-fill-hours-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  providers: [],
  templateUrl: './delete-entry-dialog.component.html',
  styleUrl: './delete-entry-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteEntryDialogComponent implements OnInit {
  _timesheetFeature = inject(TimesheetsFeatureService);
  _dialog = inject(MatDialog);
  _snackBar = inject(MatSnackBar);

  constructor() {}

  ngOnInit() {}

  deleteEntry() {
    if (this._timesheetFeature.selectedTimesheetLine() && this._timesheetFeature.selectedTimesheetLine()?.entryNo && this._timesheetFeature.selectedTimesheetLine()?.timesheetNo) {
      this._timesheetFeature
        .deleteTimesheetLine({ entryNo: this._timesheetFeature.selectedTimesheetLine()?.entryNo ?? 0, timesheetNo: this._timesheetFeature.selectedTimesheetLine()?.timesheetNo ?? '' })
        .subscribe(() => {
          this._snackBar.open('Successfully deleted entry.', undefined, { duration: 2000, horizontalPosition: 'right', verticalPosition: 'top' });
          this._dialog.closeAll();
        });
    }
  }
}
